import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtendimentoMeusComponent } from './atendimento-meus/atendimento-meus.component';
import { PesquisaModule } from '../libs/pesquisa/pesquisa.module';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';

import { GridAllModule, ContextMenuService, ContextMenuOpenEventArgs, ContextMenuItemModel } from '@syncfusion/ej2-angular-grids';
import { ReactiveFormsModule } from '@angular/forms';
import { DateRangePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { ErrorHandlerModule } from '../libs/error-handler/error-handler.module';
import { FinalizacaoModule } from '../finalizacao/finalizacao.module';
import { ButtonAllModule, CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { TagModule } from '../tag/tag.module';


import { ContextMenuModule } from '@syncfusion/ej2-angular-navigations';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';



@NgModule({
  declarations: [
    AtendimentoMeusComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DateRangePickerAllModule,
    ErrorHandlerModule,
    ButtonAllModule,
    PesquisaModule,
    DialogAllModule,
    FinalizacaoModule,
    GridAllModule,
    CheckBoxAllModule,
    TagModule,
    ContextMenuModule,
    ToastModule
  ],
  exports: [
    AtendimentoMeusComponent
  ]
})
export class AtendimentoMeusModule { }
